import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  Grid,
  Popover,
  InputBase,
  Box,
  Button,
  Hidden
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import {
  GridViewOutlined,
  WidgetsOutlined,
  DescriptionOutlined,
  TokenOutlined,
  Settings,
  KeyboardArrowDown,
  Search,
  ExpandMore,
  ExpandLess,
  HourglassBottom,
  DeveloperMode
} from "@mui/icons-material";
import { useLocation, Link, useNavigate } from "react-router-dom";
import avatarPlaceholder from '../assets/avatarSample2.jpg';
import { useTheme } from '@mui/system';
import { getCompanyName } from "../utils/utility";
import { useGlobal } from "../Context/globalContext";







const drawerWidth = 240;
// const REACT_APP_DOCUMENTATION_URL = 'https://app.gitbook.com/o/e2NFqEojmFAfnZG4xAxf/s/AE2q47Ktz8dsi3p5RJeT/';
const REACT_APP_DOCUMENTATION_URL = process.env.REACT_APP_STAGE === "production" ? 'https://hyperdart.com/docs'  : 'https://dev.hyperdart.com/docs'
const server = process.env.REACT_APP_STAGE === "production" ? "https://hyperdart.com" : "https://dev.hyperdart.com";







const Navigation = (props) => {
  const theme = useTheme();
  const [searchValue, setSearchvalue] = useState('');
  const { userData, categoriesData, bucketURLS, developerInfo } = useGlobal();



  const appBarStyles = {
    background: '#fafafa',
    color: '#333',
    boxShadow: 'none',
    width: "calc(100% - 200px)",
    left: '100px',
    borderBottom: '1px solid #E9E9E9',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      left: '0px',
    }

  }

  const menuListItemStyles = {
    "&.MenuListItem": {
      color: theme => theme.palette.primary.textColor,
      cursor: "pointer",
      margin: "10px auto",
      width: "90%",
      //  transition: "transform 0.2s ease",
      // "&:hover": {
      //   transform: "scale(1.1)"
      // }
    },
    "&.active": {
      border: (theme) => `1px solid ${theme.palette.primary.main}`,
      borderRadius: "25px",
      color: (theme) => theme.palette.primary.main,
    },
    "&.activeCategory": {
      color: (theme) => theme.palette.primary.main,
    }
  }


  const listItemIconStyles = {
    "&.menuItemIconRight": {
      display: "flex",
      justifyContent: "flex-end",
    },
    "&.menuItemIconActive": {
      color: (theme) => theme.palette.primary.main,
    },
  };

  const searchInputStyles = {
    marginLeft: "10px",
    [theme.breakpoints.down('sm')]: {
      // marginLeft: '5px',
      width: '100%'
    }
  }

  const searchBoxWrapperStyles = {
    display: "flex",
    borderRadius: "16px",
    boxShadow: "0px 0px 20px 0px #1B1B1B0F",
    marginRight: "20px",
    [theme.breakpoints.down('sm')]: {
      marginBottom: '20px',
      paddingRight: '16px',
      paddingLeft: '16px'
    }
  }

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const listItems = ["Logout"];
  const [isAllPackagesOpen, setAllPackagesOpen] = useState(false);
  const [imageAvailable, setImageAvailable] = useState(true);
  const [downloadUrl, setDownloadUrl] = useState('')
  const navigate = useNavigate();
  const location = useLocation();

  const selectedCategory = location && location.state && location.state.selectedCategory

  useEffect(() => {
    if(bucketURLS.websearch){
      setDownloadUrl(bucketURLS.websearch)
    }
  }, [bucketURLS])

  useEffect(() => {
    setSearchvalue('')
  }, [location.pathname])


  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };


  const toggleMenu = (event) => {
    setMenuAnchor(menuAnchor ? null : event.currentTarget);
  };
  const toggleAllPackages = () => {
    setAllPackagesOpen(!isAllPackagesOpen);
  };


  const isLoggedIn = userData?.is_authenticated;
  const isDeveloper = developerInfo?.role === "developer";

  let menuItems = [];

  // Always visible for logged-in or logged-out users
  const baseMenu = [
    {
      name: "Packages",
      icon: <GridViewOutlined />,
      link: '/',
      subcategories: [].concat(categoriesData),
    },
    {
      name: "Documentation",
      icon: <DescriptionOutlined />,
      link: REACT_APP_DOCUMENTATION_URL,
    },
  ];

  // CASE 1: Logged out → show only base menu (NO Developer tab)
  if (!isLoggedIn) {
    menuItems = baseMenu;
  }

  // CASE 2: Logged in but NOT developer → show Developer tab separately
  else if (isLoggedIn && !isDeveloper) {
    menuItems = [
      ...baseMenu,
      { name: "Developer", icon: <DeveloperMode />, link: "/developer-access" },
    ];
  }

  // CASE 3: Logged in AND developer → show full developer menu
  else if (isLoggedIn && isDeveloper) {
    menuItems = [
      ...baseMenu,
      { name: "My Packages", icon: <WidgetsOutlined />, link: "/my-packages" },
      { name: "Developer", icon: <DeveloperMode />, link: "/developer-access" },
    ];
  }


  const userCompany = getCompanyName(userData?.user?.email);

  // Under Review Tab
  if (userData && userData.is_authenticated && (userData.is_staff || userCompany === 'hyperdart') && process.env.REACT_APP_STAGE === "development") {
    menuItems.push({
      name: "Pending Review",
      icon: <HourglassBottom />,
      link: "/pending-review",
    });
  }

  const isCurrentPath = (link, name) => {
    // if (
    //   location.pathname.toLowerCase().includes("/package") &&
    //   name === "Packages"
    // ) {
    //   return true;
    // }
    return location.pathname === link;
  };


  const handleListItemClick = (menuItem) => {
    if (menuItem === 'Logout') {
      fetch("/nodeapi/auth/logout", {
        method: "POST",
        credentials: "include"
      })
        .then((res) => res.json())
        .then((data) => {
          if (data && data.msg === 'succesfully logged out') {
            console.log('loggedOut')
            window.location.href = `${server}/hd/login?external=${server}/partner-portal`
          }
        }


        ).catch(err => {
          console.log('error logging out!', err)

        })

    }
    setMenuAnchor(null);
  };

  const handleMenuItemClick = (item) => {
    if (item.link && item.name !== 'Documentation') {
      if (item.link === '/my-packages') {
        navigate(item.link, { state: { selectedCategory: 'my-packages' } });
      } else if (item.link === '/pending-review') {
        navigate(item.link, { state: { selectedCategory: 'pending-review' } });
      } else {
        navigate(item.link);
      }      
    } else if (item.name === 'Documentation') {
      window.open(item.link, '_blank')
    } else {
      props.handleCategory(item)
    }
  }


  const handleSearchChange = (event) => {
    setSearchvalue(event.target.value);
    const query = event.target.value;
    const params = new URLSearchParams()
    if (query) {
      params.append("search", query)
    } else {
      params.delete("search")
    }
    navigate(`?${params.toString()}`, { state: { ...location.state } });
  };

  const renderDrawerContent = (
    <List>
      {menuItems.map((menuItem) => (
        <div key={menuItem.name}>
          <ListItem
            className={`MenuListItem ${isCurrentPath(menuItem.link, menuItem.name) ? "active" : ""
              }`}
            onClick={() => handleMenuItemClick(menuItem)}
            sx={menuListItemStyles}
          >
            <ListItemIcon
              className={`menuItemIcon ${isCurrentPath(menuItem.link, menuItem.name) ? "menuItemIconActive" : ""
                }`}
              sx={listItemIconStyles}
            >
              {menuItem.icon}
            </ListItemIcon>

            <Typography variant="body1" sx={{ fontWeight: "500" }}>
              {menuItem.name}
            </Typography>

            {menuItem.name === "Packages" && (
              <ListItemIcon
                className={`menuItemIconRight ${isCurrentPath(menuItem.link, menuItem.name)
                    ? "menuItemIconActive"
                    : ""
                  }`}
                sx={listItemIconStyles}
              >
                {isAllPackagesOpen ? (
                  <ExpandLess onClick={toggleAllPackages} />
                ) : (
                  <ExpandMore onClick={toggleAllPackages} />
                )}
              </ListItemIcon>
            )}
          </ListItem>

          {menuItem.name === "Packages" && isAllPackagesOpen && (
            <List sx={{margin:0, padding:0}}>
              {menuItem.subcategories.map((subCategory) => (
                <ListItem
                  key={subCategory.categoryName}
                  className={`MenuListItem ${selectedCategory === subCategory.categoryName
                      ? "activeCategory"
                      : ""
                    }`}
                  onClick={() => handleMenuItemClick(subCategory)}
                  sx={{
                    ...menuListItemStyles,
                    pl: 6, // <-- add indentation for subcategories
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: "500" }}>
                    {subCategory.categoryName}
                  </Typography>
                </ListItem>
              ))}
            </List>
          )}
        </div>
      ))}

    </List>
  );

  const searchBox = (
    <Box sx={searchBoxWrapperStyles}>
      <IconButton>
        <Search fontSize="medium" sx={{ color: theme => theme.palette.primary.main }} />
      </IconButton>
      <InputBase
        placeholder="Search app"
        onChange={handleSearchChange}
        sx={searchInputStyles}
        value={searchValue}
      // value={props.searchValue}
      />
    </Box>
  )

  const renderHeaderContent = (

    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Grid container alignItems="center">
          <img
            src="https://dev-registry.hyperdart.com/-/static/hd_logo.png"
            alt="Logo"
            style={{
              width: "25px",
              marginRight: !isMobile ? "10px" : "0",
              cursor: 'pointer'
            }}
            onClick={() => {
              navigate('/')
            }}
          />
          {!isMobile && (
            <Typography
              variant="h6"
              style={{ color: "#F05F40" }}
            >
              App Store
            </Typography>
          )}
        </Grid>
      </Grid>
      <Grid item style={{ marginLeft: isMobile ? "auto" : "0" }}>
        <Grid container alignItems="center">
          <Grid item>
            {(selectedCategory || location.pathname === '/') && (
              <Hidden smDown>
                {searchBox}

              </Hidden>
            )}
          </Grid>
          {
            userData && userData.is_authenticated ? <Grid item style={{ display: 'flex', alignItems: 'center' }}>
              <div className="profilePicture">{
                imageAvailable && downloadUrl ? <img src={`${downloadUrl}/${userData?.profileData?.photoURL}`} alt="profile" onError={() => setImageAvailable(false)} /> :
                  <img src={avatarPlaceholder} alt="profile" onError={() => setImageAvailable(false)} />
              }</div>
              <Typography sx={{ marginLeft: '5px', fontWeight: '600' }} variant="body2">{userData?.profileData?.userName}</Typography>
              <IconButton>
                <KeyboardArrowDown fontSize="medium" style={{ color: '#F05F40' }} onClick={toggleMenu} />
              </IconButton>
            </Grid> : <Button variant="contained" size="small" sx={{ borderRadius: '25px', textTransform: 'none' }} onClick={() => {
                window.location.href = `${server}/hd/login?external=${server}/partner-portal`
            }}>Log in</Button>
          }
        </Grid>
      </Grid>
    </Grid>


  );

  return (
    <>
      <AppBar
        position="fixed"
        sx={appBarStyles}
      >
        <Toolbar>
          {isMobile && (
            <>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
              {renderHeaderContent}

            </>
          )}
          {!isMobile && renderHeaderContent}
          <Popover
            open={Boolean(menuAnchor)}
            anchorEl={menuAnchor}
            onClose={() => setMenuAnchor(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <List>
              {listItems.map((item) => (
                <ListItem
                  key={item}
                  onClick={() => handleListItemClick(item)}
                  style={{ cursor: "pointer" }}
                >
                  <ListItemText primary={item} />
                </ListItem>
              ))}
            </List>

          </Popover>
        </Toolbar>
        {(selectedCategory || location.pathname === '/') && (
          <Hidden smUp>
            {searchBox}
          </Hidden>
        )}
      </AppBar>
      {isMobile ? (
        <Drawer variant="temporary" open={drawerOpen} onClose={toggleDrawer}>
          {renderDrawerContent}
        </Drawer>
      ) : (
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: drawerWidth,
              padding: "20px 0",
              border: "none",
              left: 'auto',
              top: '75px',
              height: 'calc(100% - 150px)',
              borderRadius: "16px",
              boxShadow: " 0px 0px 20px 0px #1B1B1B0F"
            },
            '& .MuiToolbar-root': {
              height: 0,
              display: 'none',
            },
          }}
        >
          <Toolbar />
          {renderDrawerContent}
        </Drawer>
      )}
    </>
  );
};

export default Navigation;
